import React from 'react';
import { observer } from 'mobx-react';
import { FFControlIcon } from '../../../study/views/player-icons';
import { ControlButton } from './control-button';
import { usePlayerModel } from '../player-model-context';

export const ForwardButton = observer(() => {
  const model = usePlayerModel();
  return (
    <ControlButton
      onClick={() => model.forward()}
      disabled={!model.canSeekNextNavStop}
    >
      <FFControlIcon />
    </ControlButton>
  );
});
